export const dicomQueryKeys = {
  all: ['dicom-query'] as const,
  worklist: (serverId: number, filters?: any) =>
    [...dicomQueryKeys.all, 'worklist', serverId, filters] as const,
  patients: (serverId: number, filters?: any) =>
    [...dicomQueryKeys.all, 'patients', serverId, filters] as const,
  studies: (serverId: number, filters?: any) =>
    [...dicomQueryKeys.all, 'studies', serverId, filters] as const,
};


